import { render } from "./CustomizeRule.vue?vue&type=template&id=c4a1be62&scoped=true"
import script from "./CustomizeRule.vue?vue&type=script&lang=js"
export * from "./CustomizeRule.vue?vue&type=script&lang=js"

import "./CustomizeRule.vue?vue&type=style&index=0&id=c4a1be62&scoped=true&lang=less"
import "./CustomizeRule.vue?vue&type=style&index=1&id=c4a1be62&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a1be62"]])

export default __exports__